import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import UploadCarePicture from '../UploadCarePicture'

import Modal, { openModal } from '../Modal'

const isUploadeCareImage = (src) =>
  !!src.match(/^(https?:)?(\/\/)?ucarecdn\.com\/.*$/)

const ImageButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
`
export const ModalInner = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`

const Image = (props) => {
  const isUploadCare = isUploadeCareImage(props.src)
  return (
    <>
      <ImageButton onClick={() => openModal(props.src)}>
        {isUploadCare && <UploadCarePicture {...props} />}
        {!isUploadCare && <img {...props} />}
      </ImageButton>

      <Modal opacity={1} fullScreen name={props.src}>
        <ModalInner>
          {isUploadCare && <UploadCarePicture {...props} />}
          {!isUploadCare && <img {...props} />}
        </ModalInner>
      </Modal>
    </>
  )
}

Image.propTypes = {
  src: PropTypes.string.isRequired
}

export default Image
